import React from "react";

// Label + control + hint/error wrapper for TSP forms. The control itself is
// passed as children and should set id={id}, aria-invalid and
// aria-describedby={`${id}-error`} / `${id}-hint` so the message is announced.
export default function TspFormField({ id, label, required = false, error, hint, className = "", children }) {
  return (
    <div className={`tsp-form-field ${error ? "has-error" : ""} ${className}`}>
      <label htmlFor={id}>
        {label}
        {required && (
          <span className="tsp-required" aria-hidden="true">
            {" "}
            *
          </span>
        )}
      </label>
      {children}
      {error ? (
        <span id={`${id}-error`} className="tsp-field-error" role="alert">
          {error}
        </span>
      ) : (
        hint && (
          <span id={`${id}-hint`} className="tsp-field-hint">
            {hint}
          </span>
        )
      )}
    </div>
  );
}
